module.exports = __webpack_public_path__ + "static/media/transiluminator-warning.bee7f23a.svg";